import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from '@mui/material'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { ArrowBack } from '@mui/icons-material'
import MaterialTypography from '../../../components/MaterialTypography'
import { useNavigate, useSearchParams } from 'react-router-dom'
import MaterialBox from '../../../components/MaterialBox'
import MaterialSelect from "../../../components/MasterSelect"
import { usePincodeFormHandling } from './components/PincodeStateHandle'
import MaterialInput from '../../../components/MaterialInput'
import MaterialButton from '../../../components/MaterialButton'
import { useEffect, useState } from 'react'
import { fetchData, fetchDataById, postData, putData } from '../../../services'
import { useSnackbar } from '../../../context/popup'
import { setCircleLoading } from '../../../components/Loading'

const PincodeForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const {showSnackbar} = useSnackbar();
    const pincodeId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" 
    : pageType === "edit" ? "edit" : "add";
    const [originalData, setOriginalData] = useState(null);
    const [countryDropdownOptions, setCountryDropdownOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const { formData, setFormData, handleChange, checkAllFields } = usePincodeFormHandling();

    //Country Dropdown API
    useEffect(() => {
        if(pageMode!=="view"){
            const fetchCountryDropdown = async () => {
                try {
                setCircleLoading(true);
                const response = await fetchData(`/reference/general/country?dropdown=true&isActive=true`)                
                if(response?.success){
                    const formattedCountries = response?.data?.items?.map((item) => ({
                        value: item.id,
                        label: item.displayName,
                    }));                
                    setCountryDropdownOptions(formattedCountries);                
                }
                else{
                    //throw error
                }
                } catch (error) {
                console.error('Error Fetching Countries:', error);                
                showSnackbar(error?.response?.data?.message || 'Error Fetching Countries', "error");
                }finally{
                    setCircleLoading(false);
                }
            };
            fetchCountryDropdown();
        }
        
    },[pageMode])

    //State Dropdown API
    useEffect(() => {
        if (!formData.countryId?.value) return;
        const fetchStateDropdown = async (countryId) => {
            try {
            setCircleLoading(true);
            const response = await fetchData(`/reference/general/state?dropdown=true&isActive=true&countryId=${countryId}`)
            
            if(response?.success){
                const formattedStates = response?.data?.items.map((item) => ({
                value: item.id,
                label: item?.name
                }))
                setStateOptions(formattedStates);
            }
            else{
                //throw error
            }
            }       
            catch (error) {
            console.error('Error Fetching States:', error);
            showSnackbar(error?.response?.data?.message || 'Error Fetching States', "error");
            }finally{
                setCircleLoading(false);
            }
        };
        fetchStateDropdown(formData.countryId.value);
    }, [formData.countryId?.value]);

    //District Dropdown API
    useEffect(() => {
        if (!formData.stateId?.value) return;
        const fetchDistrictDropdown = async () => {
            
            try {
            setCircleLoading(true);
            const response = await fetchData(`/reference/general/district?dropdown=true&isActive=true&stateId=${formData.stateId?.value}`)
            
            if(response?.success){
                const formattedDistricts = response?.data?.items.map((item) => ({
                    value: item.id,
                    label: item?.name
                }))
                setDistrictOptions(formattedDistricts);
            }
            else{
                //throw error
            }
            } catch (error) {
            console.error('Error Fetching Districts:', error);
            showSnackbar(error?.response?.data?.message || 'Error Fetching Districts', "error");
            }finally{
                setCircleLoading(false);
            }
        }
        fetchDistrictDropdown();
    }, [formData.stateId?.value]);

    //City Dropdown API
    useEffect(() => {
        if (!formData.districtId?.value) return;
        const fetchCityDropdown = async () => {
            
            try {
            setCircleLoading(true);
            const response = await fetchData(`/reference/general/city?dropdown=true&isActive=true&districtId=${formData.districtId?.value}`)
            
            if(response?.success){
                const formattedCities = response?.data?.items.map((item) => ({
                    value: item.id,
                    label: item?.name
                }))
                setCityOptions(formattedCities);
            }
            else{
                //throw error
            }
            } catch (error) {
            console.error('Error Fetching Districts:', error);            
            showSnackbar(error?.response?.data?.message || 'Error Fetching Districts', "error");
            }finally{
                setCircleLoading(false);
            }
        }
        fetchCityDropdown();
    }, [formData.districtId?.value]);

    //data fetch by id api function
    useEffect(() => {
        if (pageMode === "add" || !pincodeId) {
            return;
        }

        //Fetch data by Pincode Id
        const fetchPincodeById = async (pincodeId) => {
            try {
            setCircleLoading(true);
            const response = await fetchDataById(`/reference/general/pincode/${pincodeId}`);

            const responseData = response?.data;
            if (response.success && responseData) {
                const mapped = {
                    code: responseData?.pincode || "",
                    active: responseData?.isActive,
                    countryId: { value: responseData?.city?.district?.state?.country?.id || "", label: responseData?.city?.district?.state?.country?.name || "" },
                    stateId: { value: responseData?.city?.district?.state?.id || "", label: responseData?.city?.district?.state?.name || "" },
                    districtId: { value: responseData?.city?.district?.id || "", label: responseData?.city?.district?.name || "" },
                    cityId: { value: responseData?.city?.id || "", label: responseData?.city?.name || "" },
                    // reset status fields
                    codeStatus: responseData?.pincode ? "success" : "unchecked",
                    countryIdStatus: responseData?.city?.district?.state?.country?.id ? "success" : "unchecked",
                    stateIdStatus: responseData?.city?.district?.state?.id ? "success" : "unchecked",
                    districtIdStatus: responseData?.city?.district?.id ? "success" : "unchecked",
                    cityIdStatus: responseData?.city?.id ? "success" : "unchecked",
                    iplCityIdStatus: responseData?.iplCityId ? "success" : "unchecked",
                };

                setFormData(mapped);   //view data
                setOriginalData(mapped);    //discard data
            }
            } catch (error) {
            console.error("Error fetching data by ID:", error);            
            showSnackbar(error?.response?.data?.message || "Error fetching data by ID", "error");
            }finally{
                setCircleLoading(false);
            }
        };

        fetchPincodeById(pincodeId);
    }, [pageMode]);

    //post and put api function
    const handleSubmitPincode = async () => {
        const payload = { 
            cityId: formData?.cityId?.value,
            pincode: formData?.code, 
            isActive: formData?.active
        };
        //Update
        if(pincodeId){
            try {
                setCircleLoading(true);
                const response = await putData(`/reference/general/pincode/${pincodeId}`, payload);
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/general-master/pincode-list');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar("Error updating Pincode","error");
            }finally{
                setCircleLoading(false);
            }
        }
        else{      
        //Submit
            try {
                setCircleLoading(true);
                const response = await postData('/reference/general/pincode', payload);
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage,"success");
                    navigate('/general-master/pincode-list');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage,"error");
                }
            } catch (error) {
                //catch error message
                console.error('Error posting data:', error);
                showSnackbar("Error submitting Pincode","error");
            }finally{
                setCircleLoading(false);
            }
        }
    };

    // Discard resets to View Data
    const handleDiscard = () => {
    if (originalData) {
        setFormData(originalData);
    }
    };

  return (
    <DashboardLayout>
        <CardHeader
            title={(
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton onClick={() => navigate("/general-master/pincode-list")}>
                        <ArrowBack/>
                        </IconButton>
                        <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            PIN Code Details
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            Enter New PIN Code Details from around the world.
                        </MaterialTypography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
        />
        <CardContent>
            <Grid2 container spacing={1}>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            PIN Code*
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                    name="code"
                    placeholder="eg. 600035"
                    value={formData.code}
                    onChange={handleChange}
                    success={formData.codeStatus === "success"}
                    error={formData.codeStatus === "error"}
                    disabled={pageMode === "view"}
                    />
                    {formData.codeStatus === "error" && (
                        <FormControl error>
                            <FormHelperText>
                            PIN Code must be 3–10 characters long and can contain letters, numbers, spaces, or hyphens.
                            </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            Country Name
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                    name="countryId"
                    value={formData.countryId}
                    onChange={handleChange}
                    options={countryDropdownOptions}
                    success={formData.countryIdStatus === "success"}
                    error={formData.countryIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            State Name
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                    name="stateId"
                    options={stateOptions}
                    value={formData.stateId}
                    onChange={handleChange}
                    success={formData.stateIdStatus === "success"}
                    error={formData.stateIdStatus === "error"}
                    isDisabled={formData.countryId === "" || pageMode === "view"}
                    />
                </Grid2> 
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            District Name
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                    name="districtId"
                    options={districtOptions}
                    value={formData.districtId}
                    onChange={handleChange}
                    success={formData.districtIdStatus === "success"}
                    error={formData.districtIdStatus === "error"}
                    isDisabled={formData.stateId === "" || pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            City Name*
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                    name="cityId"
                    options={cityOptions}
                    value={formData.cityId}
                    onChange={handleChange}
                    success={formData.cityIdStatus === "success"}
                    error={formData.cityIdStatus === "error"}
                    isDisabled={formData.districtId === "" || pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:2, md:2, sm: 2, xs: 2 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            Active
                        </MaterialTypography>
                    </MaterialBox>
                    <FormControlLabel
                    control={
                        <Switch
                            checked={formData.active}
                            disabled={pageMode === "view"}
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: "active",
                                        value: e.target.checked,
                                    },
                                })
                            }
                            color="primary"
                        />
                    }
                    label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                            {formData?.active ? "Yes" : "No"}
                        </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    />
                </Grid2>
            </Grid2>
        </CardContent>
        <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
        >
        {pageMode === "add" && (
        <>
            <MaterialButton
            sx={{ m: 2 }}
            variant="outlined"
            color="dark"
            onClick={() => navigate("/general-master/pincode-list")}
            >
            Cancel
            </MaterialButton>
            <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            disabled={!checkAllFields()}
            onClick={handleSubmitPincode}
            >
            Submit
            </MaterialButton>
        </>
        )}

        {pageMode==="edit" && (
        <>
            <MaterialButton
            variant="outlined"
            color="dark"
            sx={{ m: 2 }}
            onClick={handleDiscard}
            >
            Discard
            </MaterialButton>
            <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            disabled={!checkAllFields()}
            onClick={handleSubmitPincode}
            >
            Update
            </MaterialButton>
        </>
        )}
        </MaterialBox>
    </DashboardLayout>
  )
}

export default PincodeForm